export const LOGO_URL =
  "https://cdn.magicpatterns.com/uploads/2cFEzNMiSEa61Lhccen35m/hf_20261008_215731_687f4d79-65d8-475f-a3c9-e94d2f87371b.png";

export const MOTTO_LINES = [
  "El sueño inicia el camino,",
  "el sacrificio lo construye,",
  "la constancia lo sostiene,",
  "y el éxito, es el resultado.",
];

export const navLinks = [
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Enfoque", href: "#enfoque" },
  { label: "Contacto", href: "#contacto" },
];

export const whatsappNumbers = [
  { display: "+54 9 11 4179-7515", url: "https://wa.me/5491141797515" },
  { display: "+54 9 11 7366-0624", url: "https://wa.me/5491173660624" },
];

export const contactInfo = {
  email: "solucionesoinformacion@gmail.com",
  transfermarktUrl: "https://www.transfermarkt.es/studio-vision-pro/beraterfirma/berater/11344",
};

export const coachService = {
  title: "Asesoramiento a técnicos de fútbol",
  description:
    "También acompañamos a entrenadores: negociación de contratos, búsqueda de proyectos y planificación de su carrera en el banco.",
};

export const services = [
  {
    id: "transferencias",
    title: "Transferencias nacionales e internacionales",
    description:
      "Concretamos traspasos dentro y fuera del país, gestionando cada detalle de la operación de principio a fin.",
  },
  {
    id: "clubes",
    title: "Oportunidades en clubes",
    description:
      "Conseguimos oportunidades reales en clubes, buscando el proyecto deportivo adecuado para cada jugador.",
  },
  {
    id: "contratos",
    title: "Negociación de contratos",
    description:
      "Defendemos el valor del jugador en cada negociación: condiciones, cláusulas y plazos pensados para su crecimiento.",
  },
  {
    id: "bienestar",
    title: "Gestión médica y bienestar",
    description:
      "Coordinamos especialistas, seguimiento físico y apoyo integral para que el jugador rinda y se cuide.",
  },
  {
    id: "carrera",
    title: "Planificación de carrera",
    description:
      "Trazamos un recorrido a largo plazo, evaluando cada oportunidad según la etapa y los objetivos del jugador.",
  },
  {
    id: "imagen",
    title: "Imagen y comunicación",
    description:
      "Construimos una imagen profesional coherente, al servicio de la carrera y no al revés.",
  },
];

export const pillars = [
  {
    title: "Confianza",
    description:
      "Relaciones claras y transparentes: el jugador y su familia saben siempre qué hacemos y por qué.",
  },
  {
    title: "Estrategia",
    description:
      "Decisiones con propósito. Cada paso se evalúa pensando en la carrera completa, no solo en el próximo contrato.",
  },
  {
    title: "Compromiso",
    description:
      "Presencia en cada etapa: en los buenos momentos, en las lesiones y en las decisiones difíciles.",
  },
];

export const profileOptions = [
  "Jugador",
  "Familia / Tutor",
  "Club",
  "Otro",
];
